import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconArrowUpwardSvg } from "./IconArrowUpwardSvg.mjs";
const IconArrowUpward = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconArrowUpwardSvg, ...iconProps });
};
export {
  IconArrowUpward
};
